import React from "react";
import { useTranslation } from "react-i18next";
import { UseCases } from "@planzone/core";

import { useModal } from "@root/client/modal";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import styles from "./styles.scss";

function CreationMenu({ project }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <Safeguard useCases={[UseCases.startDiscussion]}>
      {({ canStartDiscussion }) =>
        canStartDiscussion && (
          <div className={styles.creationMenu}>
            <button
              className={styles.button}
              onClick={() =>
                pushView({
                  key: UseCases.startDiscussion,
                  data: project,
                })
              }
            >
              <div className={styles.iconBox}>+</div>
              <p>{t("projectPage.discussionsPage.add")}</p>
            </button>
          </div>
        )
      }
    </Safeguard>
  );
}

export { CreationMenu };
